import { useTranslation } from "react-i18next";
import { Card, List, Spin, Typography, Button } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useUpdates } from "../hooks/useUpdates";
import { useFormatDate } from "../hooks/useFormatDate";
import { OPEN_UPDATES_DRAWER } from "../constants/updatesDrawer";

const { Text } = Typography;

const UPDATES_LIMIT = 5;

function openUpdatesDrawer(update?: { id: number; title: string; description: string; created_at: string }) {
  window.dispatchEvent(
    new CustomEvent(OPEN_UPDATES_DRAWER, { detail: update ? { update } : {} })
  );
}

export function DashboardUpdates() {
  const { t } = useTranslation("translation");
  const formatDate = useFormatDate();
  const { updates, loading } = useUpdates({
    limit: UPDATES_LIMIT,
  });

  if (loading) {
    return (
      <Card size="small" title={<span><BellOutlined style={{ marginRight: 8 }} />Updates</span>}>
        <div style={{ textAlign: "center", padding: 16 }}>
          <Spin size="small" />
        </div>
      </Card>
    );
  }

  return (
    <Card
      size="small"
      title={<span><BellOutlined style={{ marginRight: 8 }} />Updates</span>}
    >
      {updates.length === 0 ? (
        <Text type="secondary">No updates yet.</Text>
      ) : (
        <List
          size="small"
          dataSource={updates}
          renderItem={(u) => (
            <List.Item
              style={{ padding: "4px 0", borderBlockEnd: "none", cursor: "pointer" }}
              onClick={() => openUpdatesDrawer(u)}
            >
              <span
                style={{
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#1890ff",
                }}
              >
                {u.title}
              </span>
              <Text type="secondary" style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                {formatDate(u.created_at)}
              </Text>
            </List.Item>
          )}
        />
      )}
      <div style={{ marginTop: 12, textAlign: "right" }}>
        <Button type="link" size="small" style={{ padding: 0 }} onClick={() => openUpdatesDrawer()}>
          {t("common.seeAll")}
        </Button>
      </div>
    </Card>
  );
}
